var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("AdminInventorySubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true,
      forceTab: "purchaseOrder"
    }
  }), _c("section", {
    staticClass: "content-centered large"
  }, [_vm.isForbiddenToAccessPage ? _c("Error", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  }) : _c("div", {
    staticClass: "container-centered small"
  }, [_c("h1", [_vm._v(_vm._s(_vm.$route.params.id ? "Edit/View Purchase Order" : "New Purchase Order"))]), _c("PurchaseOrderForm", {
    attrs: {
      id: _vm.$route.params.id,
      saveDraft: _vm.saveDraft,
      complete: _vm.complete,
      loggedUserData: _vm.loggedUserData
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };